
import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'O que são Agentes de IA e como podem ajudar meu negócio?',
      answer: 'Agentes de IA são assistentes virtuais inteligentes que automatizam tarefas, respondem clientes 24/7, agendam compromissos e muito mais. Eles reduzem custos operacionais e aumentam a eficiência do seu negócio.'
    },
    {
      question: 'Quanto tempo leva para criar um site com IA?',
      answer: 'Com as ferramentas de IA que utilizo, é possível criar sites profissionais em minutos. O processo completo, incluindo personalização e ajustes, geralmente leva poucos minutos e sem bugs ou erros de digitação que a maioria dos criadores de sites com IA tem.'
    },
    {
      question: 'Preciso ter conhecimento técnico para usar os agentes de IA?',
      answer: 'Não! Os agentes são configurados para serem intuitivos e fáceis de usar. Eu cuido de toda a parte técnica e você recebe uma solução pronta para usar.'
    },
    {
      question: 'Como funciona o Neuro Agents Global AI?',
      answer: 'É uma plataforma que oferece agentes de IA prontos para diversos nichos de negócio. Você pode escolher agentes especializados em vendas, atendimento, agendamento e muito mais.'
    },
    {
      question: 'Qual o investimento para ter um agente de IA personalizado?',
      answer: 'O investimento varia conforme a complexidade e funcionalidades desejadas. Entre em contato para uma consulta gratuita e receba um orçamento personalizado para suas necessidades.'
    },
    {
      question: 'Os agentes de IA funcionam em qualquer plataforma?',
      answer: 'Sim! Os agentes podem ser integrados a sites, WhatsApp, Instagram, Facebook e outras plataformas. A integração é feita de forma personalizada para seu negócio.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-16 sm:py-20 bg-dark-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12">
          <span className="text-sm font-semibold text-red-500 tracking-wider uppercase mb-4 block">
            DÚVIDAS FREQUENTES
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-white">
            Perguntas <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-red-600">Frequentes</span>
          </h2>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className={`bg-dark-800 rounded-2xl border transition-all duration-300 overflow-hidden ${
                openIndex === index ? 'border-red-600/50' : 'border-dark-600 hover:border-dark-500'
              }`}
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between p-5 sm:p-6 text-left cursor-pointer"
              >
                <span className="text-base sm:text-lg font-semibold text-white pr-4">
                  {faq.question}
                </span>
                <div className={`w-10 h-10 flex items-center justify-center rounded-full transition-all duration-300 flex-shrink-0 ${
                  openIndex === index ? 'bg-red-600 rotate-180' : 'bg-dark-700'
                }`}>
                  <i className="ri-arrow-down-s-line text-xl text-white"></i>
                </div>
              </button>
              
              <div className={`transition-all duration-300 ease-in-out ${
                openIndex === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
              }`}>
                <div className="px-5 sm:px-6 pb-5 sm:pb-6">
                  <p className="text-gray-400 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-400 mb-4">Ainda tem dúvidas?</p>
          <button 
            onClick={() => document.getElementById('contato')?.scrollIntoView({ behavior: 'smooth' })}
            className="inline-flex items-center bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white px-6 py-3 rounded-full font-semibold transition-all cursor-pointer whitespace-nowrap"
          >
            <i className="ri-message-3-line text-lg mr-2"></i>
            Fale Comigo
          </button>
        </div>
      </div>
    </section>
  );
}
